import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/projects';

export const getProjectById = async (id) => {
  return axios.get(endPoint.concat(`/${id}`)).then((res) => res);
};

export const getDocumentsByProjectId = async (id) => {
  return axios.get(endPoint.concat(`/${id}/pendingdocs`)).then(({ data }) => ({
    preDeliveryNotes: data.pre_delivery_notes,
    preprocessedDocs: data.pre_processed_docs,
    scannedDocuments: data.scanned_documents,
  }));
};

export const getProject = (id) =>
  axios
    .get(endPoint.concat(`/${id}`))
    .then((res) => res)
    .catch((error) => error.response);

export const getProjects = async () => {
  return axios
    .get(endPoint)
    .then((res) => res)
    .catch((error) => error.response);
};

export const createProject = async (data) => {
  return axios
    .post(endPoint, data)
    .then((res) => res)
    .catch((error) => error.response);
};

export const editProject = async (data) => {
  return axios
    .put(endPoint.concat('/', data.id), data)
    .then((res) => res)
    .catch((error) => error.response);
};

export const deleteProject = async (id) => {
  return axios
    .delete(endPoint.concat('/', id))
    .then((res) => res)
    .catch((error) => error.response);
};
